import { t } from '@lingui/macro';

import { Page, PageHeader, FilterContainer, PanelContainer } from '../../page-framework';
import { SiteFilter, StatusFilter, TimeRangeFilter } from '../../filters';
import HypervisorListPanel from '../../panels/ipm-list-panels/HypervisorListPanel';

export const pageId = 'vmware-hosts';

export default function HypervisorsPage() {
    return (
        <Page id={pageId}>
            <PageHeader title={t`Hypervisors`}>
                <FilterContainer>
                    <TimeRangeFilter required />
                    <StatusFilter />
                    <SiteFilter />
                </FilterContainer>
            </PageHeader>
            <PanelContainer>
                <HypervisorListPanel hideTitle flexHeight />
            </PanelContainer>
        </Page>
    );
}
